export default __webpack_public_path__ + "static/eidas-icon-02b1e6335f117bc6629c838de33dd4e8.png";